import PostApi from "../includes/logic/Api/PostApi";
import { UserGetMe } from "../store/StoreTypes";

export default class AuthApi {
  static async logout(){
    return await PostApi.sendRequest<void, void>('tg', 'logout')
  }

  static async checkLogin() {
    return await PostApi.sendRequest<UserGetMe>('tg', 'getme', {  })
  }

  static async login(login: string, password: string): Promise<any> {
    return await PostApi.sendRequest('tg', 'login', { login, password })
  }

  static async resetPassword(email: string): Promise<any> {
    return await PostApi.sendRequest('tg', 'resetpassword', { email })
  }

  static async setPassword(hash: string, password: string) {
    return await PostApi.sendRequest('tg', 'setpassword', { hash, password })
  }

  static async changePassword(target: string, current?: string) {
    return await PostApi.sendRequest('tg', 'changepassword', { target, current })
  }

  static async sendEmailConfirmCode(email: string) {
    return await PostApi.sendRequest('tg', 'sendemailconfirmcode', { email })
  }

  static async confirmEmail(code: number) {
    return await PostApi.sendRequest('tg', 'confirmemail', { code })
  }
}
